// src/IT/components/RequestTypeFields.jsx
import React from "react";

export default function RequestTypeFields({ requestType, details, setDetails }) {
  const d = details || {};

  const set = (k, v) => setDetails({ ...(details || {}), [k]: v });

  const Field = ({ label, value, onChange, placeholder }) => (
    <label className="it-field">
      <div className="it-label">{label}</div>
      <input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder={placeholder || ""} />
    </label>
  );

  const TextArea = ({ label, value, onChange, placeholder }) => (
    <label className="it-field">
      <div className="it-label">{label}</div>
      <textarea value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder={placeholder || ""} />
    </label>
  );

  if (!requestType) return null;

  switch (requestType) {
    case "License":
      return (
        <div className="it-grid2">
          <Field label="License/Product Name" value={d.product_name} onChange={(v) => set("product_name", v)} />
          <Field label="Vendor" value={d.vendor} onChange={(v) => set("vendor", v)} />
          <Field label="Quantity" value={d.quantity} onChange={(v) => set("quantity", v)} placeholder="e.g., 5" />
          <Field label="Duration" value={d.duration} onChange={(v) => set("duration", v)} placeholder="e.g., 12 months" />
          <TextArea label="Justification" value={d.justification} onChange={(v) => set("justification", v)} />
        </div>
      );

    case "Software":
      return (
        <div className="it-grid2">
          <Field label="Software Name" value={d.software_name} onChange={(v) => set("software_name", v)} />
          <Field label="Version" value={d.version} onChange={(v) => set("version", v)} />
          <Field label="OS" value={d.os} onChange={(v) => set("os", v)} placeholder="Windows/Mac/Linux" />
          <TextArea label="Purpose/Usage" value={d.purpose} onChange={(v) => set("purpose", v)} />
        </div>
      );

    case "VM":
      return (
        <div className="it-grid2">
          <Field label="Cloud/Platform" value={d.platform} onChange={(v) => set("platform", v)} placeholder="AWS/Azure/On-Prem" />
          <Field label="OS" value={d.os} onChange={(v) => set("os", v)} placeholder="Ubuntu/Windows Server..." />
          <Field label="vCPU" value={d.vcpu} onChange={(v) => set("vcpu", v)} placeholder="e.g., 4" />
          <Field label="RAM (GB)" value={d.ram_gb} onChange={(v) => set("ram_gb", v)} placeholder="e.g., 16" />
          <Field label="Storage (GB)" value={d.storage_gb} onChange={(v) => set("storage_gb", v)} placeholder="e.g., 200" />
          <Field label="Duration" value={d.duration} onChange={(v) => set("duration", v)} placeholder="e.g., 3 months" />
          <TextArea label="Purpose/Workload" value={d.purpose} onChange={(v) => set("purpose", v)} />
        </div>
      );

    case "Hardware":
      return (
        <div className="it-grid2">
          <Field label="Hardware Type" value={d.hardware_type} onChange={(v) => set("hardware_type", v)} placeholder="Monitor/Docking/Headset..." />
          <Field label="Quantity" value={d.quantity} onChange={(v) => set("quantity", v)} />
          <Field label="Location" value={d.location} onChange={(v) => set("location", v)} placeholder="Office/Home" />
          <TextArea label="Specs / Notes" value={d.specs} onChange={(v) => set("specs", v)} />
        </div>
      );

    case "Laptop":
      return (
        <div className="it-grid2">
          <Field label="Preferred Model" value={d.model} onChange={(v) => set("model", v)} placeholder="e.g., Dell Latitude" />
          <Field label="RAM" value={d.ram} onChange={(v) => set("ram", v)} placeholder="e.g., 16GB" />
          <Field label="Storage" value={d.storage} onChange={(v) => set("storage", v)} placeholder="e.g., 512GB SSD" />
          <Field label="OS" value={d.os} onChange={(v) => set("os", v)} placeholder="Windows/Mac" />
          <TextArea label="Reason / Notes" value={d.reason} onChange={(v) => set("reason", v)} />
        </div>
      );

    case "Research":
      return (
        <div className="it-grid2">
          <Field label="Topic" value={d.topic} onChange={(v) => set("topic", v)} />
          <Field label="Duration" value={d.duration} onChange={(v) => set("duration", v)} placeholder="e.g., 2 weeks" />
          <TextArea label="Objective" value={d.objective} onChange={(v) => set("objective", v)} />
          <TextArea label="Tools/Resources Needed" value={d.tools} onChange={(v) => set("tools", v)} />
        </div>
      );

    default:
      return (
        <div className="it-grid2">
          <TextArea label="Extra Details" value={d.notes} onChange={(v) => set("notes", v)} />
        </div>
      );
  }
}
